import { Directive, HostListener } from '@angular/core';

/**
 * Directive to stop the propagation of keydown events.
 */
@Directive({
  selector: '[p2fStopPropagation]'
})
export class StopPropagationDirective {

  /**
   * Stops the propagation of keydown events.
   *
   * @param event Keyboard event.
   */
  @HostListener('keydown', ['$event'])
  onClick(event: KeyboardEvent) {
    event.stopPropagation();
  }

}
